module.exports = __webpack_public_path__ + "static/media/shipping_old@2x.0f5d0f74.jpg";